// eslint-disable-next-line no-unused-vars
import DiscountType from '@/constants/subBubbleAgreement/SubBubbleAgreementDiscountType'

export default class SubBubbleAgreementDiscountDTO {
  constructor({
    id,
    classificationId,
    discountType,
    value,
    candidateCount,
  } = {}) {
    /**
     * @type {Number}
     */
    this.id = id
    /**
     * @type {Number}
     */
    this.classificationId = classificationId
    /**
     * @type {DiscountType}
     */
    this.discountType = discountType
    /**
     * @type {Number}
     */
    this.value = value
    /**
     * @type {Number}
     */
    this.candidateCount = candidateCount
  }
}
